<div class="main-modal-container">
  <div class="close-modal-container">
    <img
      (click)="closeModal()"
      src="/assets/icons/ close-modal-icon.png"
      alt=""
    />
  </div>
  <div class="modal-content">
    <!-- 
      **
      * Add Request Type
      *
     -->
    <ng-container *ngIf="modalType == 'addRequest'" [formGroup]="form">
      <h1 class="label-title">Add Request Type</h1>
      <label class="action-label">Action</label>
      <gbui-input
        simple
        formControlName="action"
        placeholder="Enter Request Type Here"
      >
      </gbui-input>
      <button
        (click)="createRequestType()"
        class="modal-button"
        gbui-button
        [busy]="(createRequestTypeLoading$ | async) ?? false"
        [disabled]="form.invalid"
        type="submit"
      >
        Save
      </button>
    </ng-container>

    <!-- 
      **
      * Edit Request Type
      *
     -->
    <ng-container *ngIf="modalType == 'editRequest'" [formGroup]="form">
      <h1 class="label-title">Edit Request Type</h1>
      <h3>Indicate what type of action you require:</h3>
      <div class="action-container">
        <label class="action-label-edit">Action</label>
        <gbui-input
          formControlName="action"
          class="edit-button"
          simple
          placeholder=""
        >
        </gbui-input>
      </div>
      <button
        (click)="editRequestType()"
        class="modal-button"
        gbui-button
        type="submit"
        [busy]="(editRequestTypeLoading$ | async) ?? false"
      >
        Save
      </button>
    </ng-container>

    <!-- 
      **
      * Delete Request Type
      *
     -->
    <ng-container *ngIf="modalType == 'deleteRequest'">
      <div class="deleteRequest">
        <h1 class="label-title">Delete Request Type</h1>
        <div class="container">
          <img src="/assets/icons/request-icon.png" alt="" />
          <label for="">{{ request.actionName || "" }}</label>
        </div>
        <h3>Are you sure you want to delete this request type?</h3>
        <button
          (click)="deleteRequestType()"
          class="modal-button"
          gbui-button
          type="submit"
          [busy]="(deleteRequestTypeLoading$ | async) ?? false"
        >
          Delete
        </button>
      </div>
    </ng-container>

    <!-- 
      **
      * Delete Request Type Success
      *
     -->
    <ng-container *ngIf="modalType == 'deleteRequestSuccess'">
      <div class="deleteRequestSuccess">
        <img
          class="modal-success-icon"
          src="/assets/icons/success-modal-icon.png"
          alt=""
        />
        <h1 class="label-title">Deleted Successfully</h1>

        <h3>Request type has been deleted successfully.</h3>
        <button
          (click)="closeModal()"
          class="modal-button"
          gbui-button
          type="submit"
        >
          Go Back
        </button>
      </div>
    </ng-container>
    <!-- 
      **
      * Delete Request Type Success
      *
     -->
    <ng-container *ngIf="modalType == 'changeType'">
      <div class="change-type-wrapper">
        <h1 class="label-title">
          Are you sure you want to change the Request configurations?
        </h1>

        <h3>All new requests made from now on will follow the new logic.</h3>
        <div class="buttons-wrapper">
          <button
            (click)="closeModal()"
            class="buttons-outline"
            gbui-button
            type="submit"
          >
            Close
          </button>
          <button
            (click)="updateRequestActionsType()"
            class="modal-button"
            gbui-button
            type="submit"
            [busy]="(changingRequestActionType$ | async) ?? false"
          >
            Accept
          </button>
        </div>
      </div>
    </ng-container>
  </div>
</div>
